/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Mobx model(s) related to ChannelRemediationByBook
 *
 * @file ChannelRemediationByBook.js
 * @author Mohamed yasar arabath M
 */

import { applySnapshot, types } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const ChannelRemediationByBook = types.model(
  'ChannelRemediationByBook',
  {
    byChaptersAssets: types.maybeNull(types.frozen())
  }
).actions(self => ({
  /**
   * fetch remediation by book
   *
   * @param {Object} data - The data to fetch remediation by book
   * @returns {void}
   */
  fetch(data) {
    Framework.getEventManager().publish(constants.CHANNEL_REMEDIATION_BY_BOOK_REQUESTED, data);
  },
  /**
   * Set remediation data
   *
   * @param {Object} data - The data to set remediation data
   * @returns {void}
   */
  setRemediationData(data) {
    const { chapters } = data || {};

    if (chapters && chapters.length > 0) {
      const filteredChapters = chapters.filter(chapter => chapter !== null && chapter !== undefined);
      const assets = filteredChapters.flatMap((chapter) => {
        const { topic, assets: chapterAssets } = chapter || {};
        const { assets: topicAssets } = topic || {};

        return topicAssets.map(currentAsset => chapterAssets[currentAsset] || null);
      }).filter(Boolean);

      applySnapshot(self, { byChaptersAssets: assets });
    } else {
      this.reset();
    }
  },
  /**
   * Reset remediation data
   *
   * @returns {void}
   */
  reset() {
    applySnapshot(self, { byChaptersAssets: [] });
  }
}));

export default ChannelRemediationByBook;
